export const getData = async () => {
  const response = await fetch('/api')
  if(!response.ok) throw new Error('API response error');
  return await response.json();
}

export const sortByStartYear = (firstData, secondData) => {
  return firstData['start'] - secondData['start'];
}

const determineGridRow = (layoutSpacer, category, startYear, endYear) => {
  layoutSpacer[category] = layoutSpacer[category] || {};
  
  let row = 1;
  let positionFound;
  
  while(!positionFound){
    layoutSpacer[category][`row${row}`] = layoutSpacer[category][`row${row}`] || {};

    if(!layoutSpacer[category][`row${row}`][startYear]){
      let currentYear = startYear;
      let n = 0;
      // reserve time on timeline for the event, or for single year events a block of 40 years
      while(currentYear <= endYear || (n < 40 && (startYear === endYear))){
        layoutSpacer[category][`row${row}`][currentYear] = true;
        currentYear++;
        n++;
      }
      positionFound = true;
    } else {
      row++;
    }
  }
  return row;
}

export const processData = (data) => {
  const layoutSpacer = {};
  const eventsData =  data.sort(sortByStartYear).reduce((store, event) => {
    store[event.category] = store[event.category] || {};

    const startYear = event.start;
    const endYear = event.end;
    const duration = parseInt(endYear)-parseInt(startYear)+1;

    const row = determineGridRow(layoutSpacer, event.category, startYear, endYear);
    
    store[event.category][event.id] = {
      start: startYear,
      end: endYear,
      duration: duration,
      title: event.name,
      row: row,
    }
    return store;
  }, {})

  const firstYear = data[0].start -1;
  const lastYear = data[data.length -1].end;
  
  return {
    eventsData,
    firstYear,
    lastYear,
  }
}

export const getCategoryColor = (i) => {
  const categoryColors = [
    '#ff595e',
    '#073b4c',
    '#ffbd00',
    '#06d6a0',
    '#118ab2',
    '#9c27b0',
  ];
  const colorPickIndex = ((i) % categoryColors.length);
  return categoryColors[colorPickIndex];
}

export const generateCategoryStatus = (categories) => {
  const categoriesToHide = ['Dutch history', 'US presidents'];
  return categories.reduce((store, category) => {
    store[category] = !categoriesToHide.includes(category);
    return store;
  }, {})
}
